import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CONTACT, TRADE_CATEGORIES } from "@/data/products";
import { Reveal } from "@/components/Reveal";

const Products = () => {
  return (
    <section id="products" data-testid="products-section" className="bg-sand px-6 py-14 sm:px-12 sm:py-28 lg:px-20 lg:py-36">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-8">
            <div>
              <p className="flex items-center gap-4 font-accent text-[11px] font-semibold tracking-[0.35em] text-crimson">
                <span className="h-px w-12 bg-crimson" /> PRODUCT RANGE
              </p>
              <h2 className="mt-6 font-display text-3xl font-normal leading-tight tracking-tight sm:text-4xl lg:text-5xl">
                What we <span className="italic text-crimson">trade in.</span>
              </h2>
            </div>
            <p className="max-w-md text-sm font-light leading-relaxed text-clay sm:text-base">
              A wide, mixed range across textile categories. Open any category to see the full
              line-up — current stock and rates on request.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {TRADE_CATEGORIES.map((c, i) => (
            <Reveal key={c.id} delay={(i % 3) * 0.08} className="h-full">
              <Link
                to={`/products/${c.id}`}
                data-testid={`product-card-${c.id}`}
                className="group flex h-full flex-col border border-ink/10 bg-parchment p-8 transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1 hover:border-crimson/50 hover:shadow-[0_30px_60px_-30px_rgba(253,1,25,0.3)]"
              >
                <span className="font-mono text-xs tracking-[0.25em] text-crimson">{c.n}</span>
                <h3 className="mt-5 font-display text-2xl font-semibold tracking-tight">{c.name}</h3>
                <p className="mt-3 flex-1 font-mono text-[10px] uppercase tracking-[0.18em] text-clay">
                  {c.items.length} lines stocked
                </p>
                <span className="mt-7 flex items-center gap-2.5 self-start font-body text-xs font-semibold tracking-wide text-ink/70 transition-colors duration-300 group-hover:text-crimson">
                  View category
                  <span className="flex h-8 w-8 items-center justify-center rounded-full border border-ink/20 transition-[background-color,color,border-color] duration-300 group-hover:border-crimson group-hover:bg-crimson group-hover:text-parchment">
                    <ArrowUpRight size={13} />
                  </span>
                </span>
              </Link>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <p className="mt-12 text-center font-mono text-[11px] uppercase leading-relaxed tracking-[0.2em] text-clay">
            Category photos to be added —{" "}
            <a
              data-testid="products-whatsapp-link"
              href={CONTACT.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="text-crimson underline-offset-4 hover:underline"
            >
              message us on WhatsApp
            </a>{" "}
            for the current catalogue and rates.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Products;
